
import { useUser } from '../../../contexts/UserContext'
import { Building2, ShieldCheck } from 'lucide-react'

export function TenantBadge() {
    const { user, session } = useUser()
    // INV-03: Tenant Inference (from token or context, not UI param)
    // NOTE: In this app architecture, user.id or metadata often maps to tenant.
    // For Phase 1, we display the User Identity as the "Tenant Scope".

    // In a real multi-tenant setup, this would come from a specific claim.
    // Assuming 'sub' or explicit metadata if available. 
    // For now, we use the user's email domain or ID as a proxy for "Identity Context".

    const tenantLabel = user?.email || 'Unknown Tenant'
    const role = session?.user?.app_metadata?.role || 'user' // Fallback to standard Supabase RBAC location or default

    return (
        <div className="flex items-center gap-4 bg-white/5 border border-white/10 rounded-lg px-4 py-2">
            <div className="flex items-center gap-2">
                <Building2 className="w-4 h-4 text-blue-400" />
                <div className="flex flex-col">
                    <span className="text-[10px] text-gray-400 uppercase tracking-wider leading-none">Identity / Tenant</span>
                    <span className="text-sm font-medium text-white leading-tight truncate max-w-[150px]" title={tenantLabel}>
                        {tenantLabel}
                    </span>
                </div>
            </div>

            <div className="h-8 w-px bg-white/10 mx-2"></div>

            <div className="flex items-center gap-2">
                <ShieldCheck className={`w-4 h-4 ${role === 'admin' ? 'text-purple-400' : 'text-gray-400'}`} />
                <div className="flex flex-col">
                    <span className="text-[10px] text-gray-400 uppercase tracking-wider leading-none">Role</span>
                    <span className="text-sm font-medium text-white leading-tight capitalize">
                        {role}
                    </span>
                </div>
            </div>
        </div>
    )
}
